import { render, staticRenderFns } from "./m-latestTx.vue?vue&type=template&id=65bbc397&scoped=true&"
import script from "./m-latestTx.vue?vue&type=script&lang=ts&"
export * from "./m-latestTx.vue?vue&type=script&lang=ts&"
import style0 from "./m-latestTx.vue?vue&type=style&index=0&id=65bbc397&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bbc397",
  null
  
)

export default component.exports